import { makeConfig } from './config.common';

const config = makeConfig({});

export default config;
